let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k3CXE")).then(() => parcelRequire('f6tst'));